const explorerSidebarComponentModule = {
  namespaced: true,
  modules: {},
  state: () => ({
    value: false
  }),
  getters: {},
  mutations: {
    toggleSidebar(state, value) {
      state.value = value == 'toggle' ? !state.value : value;
    }
  },
  actions: {}
};

export default explorerSidebarComponentModule;
